import { render, staticRenderFns } from "./NSingleAudioUploader.vue?vue&type=template&id=63630e6e&scoped=true&"
import script from "./NSingleAudioUploader.vue?vue&type=script&lang=js&"
export * from "./NSingleAudioUploader.vue?vue&type=script&lang=js&"
import style0 from "./NSingleAudioUploader.vue?vue&type=style&index=0&id=63630e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63630e6e",
  null
  
)

export default component.exports